import React, { useState } from 'react';
import './VerificationForm.css';

const VerificationForm = () => {
    const [formData, setFormData] = useState({
        referenceNumber: '',
        passportNumber: ''
    });
    
    const [verificationResult, setVerificationResult] = useState(null);
    const [isSearching, setIsSearching] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSearching(true);
        
        // Simulated data source - add more records here as needed
        const records = [
            {
                referenceNumber: 'REF-NL-2025-190',
                passportNumber: 'SK1336622',
                result: {
                    referenceNo: 'REF-NL-2025-190',
                    passportNo: 'SK1336622',
                    name: 'Amaz Iqbal',
                    dateOfBirth: '17-10-1997',
                    courseEvents: 'Franchise & Retail Management',
                    courseDate: '24-28 November 2025',
                    status: 'Confirmed',
                    location: 'Netherlands'
                }
            },
            {
                referenceNumber: 'MEH-2025-123',
                passportNumber: 'JK1793213',
                result: {
                    referenceNo: 'MEH-2025-123',
                    passportNo: 'JK1793213',
                    name: 'Liaqat Ali',
                    dateOfBirth: '23 April 1989',
                    courseEvents: 'Environment and Sustainability Training',
                    courseDate: '15-19 Dec 2025',
                    status: 'Confirmed',
                    location: 'Manchester, UK'
                }
            },
            {
                referenceNumber: 'MEH-2025-121',
                passportNumber: 'RV6801051',
                result: {
                    referenceNo: 'MEH-2025-121',
                    passportNo: 'RV6801051',
                    name: 'Junaid Hassan',
                    dateOfBirth: '5 November 2002',
                    courseEvents: 'Food & Culinary Skills Training',
                    courseDate: '17-23 Dec 2025',
                    status: 'Confirmed',
                    location: 'Manchester, UK'
                }
            },
            {
                referenceNumber: 'MEH-2025-122',
                passportNumber: 'CJ6217741',
                result: {
                    referenceNo: 'MEH-2025-122',
                    passportNo: 'CJ6217741',
                    name: 'Ameer Hamza',
                    dateOfBirth: '5 January 2004',
                    courseEvents: 'Food & Culinary Skills Training',
                    courseDate: '5-19 Dec 2025',
                    status: 'Confirmed',
                    location: 'Manchester, UK'
                }
            },
            {
                referenceNumber: 'MEH-2025-126',
                passportNumber: 'AS1014745',
                result: {
                    referenceNo: 'MEH-2025-126',
                    passportNo: 'AS1014745',
                    name: 'Syed Naseer Abbas',
                    dateOfBirth: '2 April 1975',
                    courseEvents: 'Christmas & New Year Iceland Travel Programme',
                    courseDate: '24 December 2025 – 2 January 2026',
                    status: 'Confirmed',
                    location: 'Reykjavik, Iceland'
                }
            },
            {
                referenceNumber: 'MEH-2025-124',
                passportNumber: 'EZ6853521',
                result: {
                    referenceNo: 'MEH-2025-124',
                    passportNo: 'EZ6853521',
                    name: 'Muhammad Awais Waseem',
                    dateOfBirth: '06 Sep 2001',
                    courseEvents: 'Christmas & New Year Iceland Travel Programme',
                    courseDate: '24 December 2025 – 2 January 2026',
                    status: 'Confirmed',
                    location: 'Reykjavik, Iceland'
                }
            },
            {
                referenceNumber: 'MEH-2025-125',
                passportNumber: 'CC6850332',
                result: {
                    referenceNo: 'MEH-2025-125',
                    passportNo: 'CC6850332',
                    name: 'Muhammad Waseem',
                    dateOfBirth: '27 Sep 1991',
                    courseEvents: 'Christmas & New Year Iceland Travel Programme',
                    courseDate: '24 December 2025 – 2 January 2026',
                    status: 'Confirmed',
                    location: 'Reykjavik, Iceland'
                }
            },
            {
                referenceNumber: 'MEH-2025-127',
                passportNumber: 'GE6972101',
                result: {
                    referenceNo: 'MEH-2025-127',
                    passportNo: 'GE6972101',
                    name: 'Irfan Haider',
                    dateOfBirth: '2 Dec 1997',
                    courseEvents: 'Christmas & New Year Iceland Travel Programme',
                    courseDate: '24 December 2025 – 2 January 2026',
                    status: 'Confirmed',
                    location: 'Iceland'
                }
            },
            {
                referenceNumber: 'MEH-2025-128',
                passportNumber: 'FC8964423',
                result: {
                    referenceNo: 'MEH-2025-128',
                    passportNo: 'FC8964423',
                    name: 'Zeeshan Farooq',
                    dateOfBirth: '15 Oct 1992',
                    courseEvents: 'Christmas & New Year Iceland Travel Programme',
                    courseDate: '24 December 2025 – 2 January 2026',
                    status: 'Confirmed',
                    location: 'Iceland'
                }
            },
            {
                referenceNumber: 'MEH-2025-129',
                passportNumber: 'UU1015181',
                result: {
                    referenceNo: 'MEH-2025-129',
                    passportNo: 'UU1015181',
                    name: 'Muhammad Awais',
                    dateOfBirth: '01 Mar 2000',
                    courseEvents: 'Christmas & New Year Iceland Travel Programme',
                    courseDate: '24 December 2025 – 2 January 2026',
                    status: 'Confirmed',
                    location: 'Iceland'
                }
            },
            {
                referenceNumber: 'MEH-2025-130',
                passportNumber: 'A06748686',
                result: {
                    referenceNo: 'MEH-2025-130',
                    passportNo: 'A06748686',
                    name: 'Rakib Ahmed',
                    dateOfBirth: '06 Jun 2000',
                    courseEvents: 'Christmas & New Year Iceland Travel Programme',
                    courseDate: '23 December 2025 – 2 January 2026',
                    status: 'Confirmed',
                    location: 'Iceland'
                }
            },
            {
                referenceNumber: 'MEH-2025-131',
                passportNumber: 'AD0732822',
                result: {
                    referenceNo: 'MEH-2025-131',
                    passportNo: 'AD0732822',
                    name: 'Muhammad Muneeb',
                    dateOfBirth: '28 Sep 1998',
                    courseEvents: 'Christmas & New Year Iceland Travel Programme',
                    courseDate: '23 December 2025 – 2 January 2026',
                    status: 'Confirmed',
                    location: 'Iceland'
                }
            },
            {
                referenceNumber: 'MEH-2025-132',
                passportNumber: 'A07976799',
                result: {
                    referenceNo: 'MEH-2025-132',
                    passportNo: 'A07976799',
                    name: 'Md Rubel Hossain',
                    dateOfBirth: '05 May 1993',
                    courseEvents: 'Christmas & New Year Iceland Travel Programme',
                    courseDate: '24 December 2025 – 2 January 2026',
                    status: 'Confirmed',
                    location: 'Iceland'
                }
            },
            {
                referenceNumber: 'MEH-2025-133',
                passportNumber: 'DD2851583',
                result: {
                    referenceNo: 'MEH-2025-133',
                    passportNo: 'DD2851583',
                    name: 'Muhammad Usama',
                    dateOfBirth: '22 Sep 1994',
                    courseEvents: 'Christmas & New Year Iceland Travel Programme',
                    courseDate: '24 December 2025 – 2 January 2026',
                    status: 'Confirmed',
                    location: 'Iceland'
                }
            },
            {
                referenceNumber: 'MEH-2025-134',
                passportNumber: 'A19719981',
                result: {
                    referenceNo: 'MEH-2025-134',
                    passportNo: 'A19719981',
                    name: 'Sheikh Md Habib Ur Rahman',
                    dateOfBirth: '25 Nov 1993',
                    courseEvents: 'Christmas & New Year Iceland Travel Programme',
                    courseDate: '23 November 2025 – 2 December 2025',
                    status: 'Confirmed',
                    location: 'Iceland'
                }
            },
            {
                referenceNumber: 'MEH-2025-135',
                passportNumber: 'A17805692',
                result: {
                    referenceNo: 'MEH-2025-135',
                    passportNo: 'A17805692',
                    name: 'Nur Mohammed',
                    dateOfBirth: '15 Jun 1980',
                    courseEvents: 'Christmas & New Year Iceland Travel Programme',
                    courseDate: '23 December 2025 – 2 January 2026',
                    status: 'Confirmed',
                    location: 'Iceland'
                }
            },
            {
                referenceNumber: 'MEH-2025-136',
                passportNumber: 'ER1986954',
                result: {
                    referenceNo: 'MEH-2025-136',
                    passportNo: 'ER1986954',
                    name: 'Mubashar Hussain Arif',
                    dateOfBirth: '12 Aug 1997',
                    courseEvents: 'Christmas & New Year Iceland Travel Programme',
                    courseDate: '24 December 2025 – 2 January 2026',
                    status: 'Confirmed',
                    location: 'Iceland'
                }
            },
            {
                referenceNumber: 'MEH-2025-137',
                passportNumber: 'RY4152621',
                result: {
                    referenceNo: 'MEH-2025-137',
                    passportNo: 'RY4152621',
                    name: 'Nabeel Khalid',
                    dateOfBirth: '07 Feb 2002',
                    courseEvents: 'Christmas & New Year Iceland Travel Programme',
                    courseDate: '23 December 2025 – 2 January 2026',
                    status: 'Confirmed',
                    location: 'Iceland'
                }
            },
            {
                referenceNumber: 'MEH-UK-2025-001',
                passportNumber: 'SM9898962',
                result: {
                    referenceNo: 'MEH-UK-2025-001',
                    passportNo: 'SM9898962',
                    name: 'Ali Raza',
                    dateOfBirth: '15 Nov 1999',
                    courseEvents: 'Christmas & New Year UK Travel Programme',
                    courseDate: '24 December 2025 – 2 January 2026',
                    status: 'Confirmed',
                    location: 'UK'
                }
            },
            {
                referenceNumber: 'MEH-UK-2025-002',
                passportNumber: 'CW7964013',
                result: {
                    referenceNo: 'MEH-UK-2025-002',
                    passportNo: 'CW7964013',
                    name: 'Muhammad Tariq',
                    dateOfBirth: '04 Dec 1997',
                    courseEvents: 'Christmas & New Year UK Travel Programme',
                    courseDate: '24 December 2025 – 2 January 2026',
                    status: 'Confirmed',
                    location: 'UK'
                }
            },
            {
                referenceNumber: 'MEH-UK-2025-003',
                passportNumber: 'ND6800832',
                result: {
                    referenceNo: 'MEH-UK-2025-003',
                    passportNo: 'ND6800832',
                    name: 'Usama Husnain',
                    dateOfBirth: '24 July 1999',
                    courseEvents: 'Christmas & New Year UK Travel Programme',
                    courseDate: '24 December 2025 – 2 January 2026',
                    status: 'Confirmed',
                    location: 'UK'
                }
            },
            {
                referenceNumber: 'MEH-2025-138',
                passportNumber: 'NM2743292',
                result: {
                    referenceNo: 'MEH-2025-138',
                    passportNo: 'NM2743292',
                    name: 'Aziz Ullah',
                    dateOfBirth: '01 Jan 1984',
                    courseEvents: 'Christmas & New Year Iceland Travel Programme',
                    courseDate: '23 December 2025 – 02 January 2026',
                    status: 'Confirmed',
                    location: 'Iceland'
                }
            },
            {
                referenceNumber: 'MEH-2025-139',
                passportNumber: 'AS8919003',
                result: {
                    referenceNo: 'MEH-2025-139',
                    passportNo: 'AS8919003',
                    name: 'Muhammad Fiaz',
                    dateOfBirth: '05 Mar 1980',
                    courseEvents: 'Christmas & New Year Iceland Travel Programme',
                    courseDate: '24 December 2025 – 03 January 2026',
                    status: 'Confirmed',
                    location: 'Iceland'
                }
            },
            {
                referenceNumber: 'MEH-2025-140',
                passportNumber: 'FW1848392',
                result: {
                    referenceNo: 'MEH-2025-140',
                    passportNo: 'FW1848392',
                    name: 'Muhammad Azhar',
                    dateOfBirth: '06 Mar 1979',
                    courseEvents: 'Christmas & New Year Iceland Travel Programme',
                    courseDate: '24 December 2025 – 03 January 2026',
                    status: 'Confirmed',
                    location: 'Iceland'
                }
            },
            {
                referenceNumber: 'MEH-UK-2025-007',
                passportNumber: 'DH6904422',
                result: {
                    referenceNo: 'MEH-UK-2025-007',
                    passportNo: 'DH6904422',
                    name: 'Sadam Hussain',
                    dateOfBirth: '21 Dec 1994',
                    courseEvents: 'New Year UK Travel Programme',
                    courseDate: '30 December 2025 – 7 January 2026',
                    status: 'Confirmed',
                    location: 'UK'
                }
            },
            {
                referenceNumber: 'MEH-SE-2025-001',
                passportNumber: 'JU1510821',
                result: {
                    referenceNo: 'MEH-SE-2025-001',
                    passportNo: 'JU1510821',
                    name: 'IBRAR AFZAL',
                    dateOfBirth: '09 Sep 2001',
                    courseEvents: 'New Year Sweden Travel Programme',
                    courseDate: '28 December 2025 – 6 Jan 2026',
                    status: 'Confirmed',
                    location: 'Sweden'
                }
            },
            {
                referenceNumber: 'MEH-SE-2025-002',
                passportNumber: 'DY5148495',
                result: {
                    referenceNo: 'MEH-SE-2025-002',
                    passportNo: 'DY5148495',
                    name: 'HAMZA SHAH WALI KHAN',
                    dateOfBirth: '29 Jun 2001',
                    courseEvents: 'New Year Sweden Travel Programme',
                    courseDate: '28 December 2025 – 6 Jan 2026',
                    status: 'Confirmed',
                    location: 'Sweden'
                }
            },
            {
                referenceNumber: 'MEH-2025-141',
                passportNumber: 'SY1178001',
                result: {
                    referenceNo: 'MEH-2025-141',
                    passportNo: 'SY1178001',
                    name: 'HUSSNAIN AHMED',
                    dateOfBirth: '22 Jul 2001',
                    courseEvents: 'New Year Iceland Travel Programme',
                    courseDate: '29 December 2025 – 6 Jan 2026',
                    status: 'Confirmed',
                    location: 'Iceland'
                }
            },
            {
                referenceNumber: 'MEH-2025-142',
                passportNumber: 'FT6909142',
                result: {
                    referenceNo: 'MEH-2025-142',
                    passportNo: 'FT6909142',
                    name: 'MALIK TAYUB HUSAIN',
                    dateOfBirth: '04 Aug 1992',
                    courseEvents: 'New Year Iceland Travel Programme',
                    courseDate: '29 December 2025 – 6 Jan 2026',
                    status: 'Confirmed',
                    location: 'Iceland'
                }
            },
            {
                referenceNumber: 'MEH-SE-2025-003',
                passportNumber: 'CA6822952',
                result: {
                    referenceNo: 'MEH-SE-2025-003',
                    passportNo: 'CA6822952',
                    name: 'Muhammad Shahzaib Yasir',
                    dateOfBirth: '04 Mar 2003',
                    courseEvents: 'Travel Participation and Tour Coordination Confirmation.',
                    courseDate: '29 Jan 2026 – 6 Feb 2026',
                    status: 'Confirmed',
                    location: 'Sweden'
                }
            },
            {
                referenceNumber: 'MEH-GRC-2026-101',
                passportNumber: 'YG1798923',
                result: {
                    referenceNo: 'MEH-GRC-2026-101',
                    passportNo: 'YG1798923',
                    name: 'Danish Ali',
                    dateOfBirth: '20 Feb 1992',
                    courseEvents: 'Travel Participation and Tour Coordination Confirmation.',
                    courseDate: '26 January 2026 – 04 February 2026',
                    status: 'Confirmed',
                    location: 'Greece'
                }
            },
            {
                referenceNumber: 'MEH-SE-2025-004',
                passportNumber: 'EY9615512',
                result: {
                    referenceNo: 'MEH-SE-2025-004',
                    passportNo: 'EY9615512',
                    name: 'Aqib Nawaz',
                    dateOfBirth: '09 Mar 1997',
                    courseEvents: 'Travel Participation and Tour Coordination Confirmation.',
                    courseDate: '29 Jan 2026 – 6 Feb 2026',
                    status: 'Confirmed',
                    location: 'Sweden'
                }
            },
            {
                referenceNumber: 'MEH-SE-2025-005',
                passportNumber: 'GH1822072',
                result: {
                    referenceNo: 'MEH-SE-2025-005',
                    passportNo: 'GH1822072',
                    name: 'Sarmad Ali',
                    dateOfBirth: '18 Dec 2004',
                    courseEvents: 'Travel Participation and Tour Coordination Confirmation.',
                    courseDate: '29 Jan 2026 – 6 Feb 2026',
                    status: 'Confirmed',
                    location: 'Sweden'
                }
            },
            {
                referenceNumber: 'MEH-LT-2026-012',
                passportNumber: 'AJ6178104',
                result: {
                    referenceNo: 'MEH-LT-2026-012',
                    passportNo: 'AJ6178104',
                    name: 'Khizar Hayat',
                    dateOfBirth: '26 Apr 1987',
                    courseEvents: 'Transport & Logistics Training and Workshop Program',
                    courseDate: '05 March 2026 to 10 March 2026',
                    status: 'Confirmed',
                    location: 'Lithuania'
                }
            },
            {
                referenceNumber: 'MEH-HA-2026-015',
                passportNumber: 'AS8919003',
                result: {
                    referenceNo: 'MEH-HA-2026-015',
                    passportNo: 'AS8919003',
                    name: 'Muhammad Fiaz',
                    dateOfBirth: '05 Mar 1980',
                    courseEvents: 'Construction & Skilled Trades Professional Development Program',
                    courseDate: '07 March 2026 to 13 March 2026',
                    status: 'Confirmed',
                    location: 'Hungary'
                }
            },
            {
                referenceNumber: 'MEH-NA-2026-034',
                passportNumber: 'V5520056',
                result: {
                    referenceNo: 'MEH-NA-2026-034',
                    passportNo: 'V5520056',
                    name: 'Tajinderpal Singh',
                    dateOfBirth: '20 Aug 2004',
                    courseEvents: 'Leadership & Personal Development Program',
                    courseDate: '01 April 2026 to 07 April 2026',
                    status: 'Confirmed',
                    location: 'Netherlands'
                }
            },
            {
                referenceNumber: 'MEH-FI-2026-012',
                passportNumber: 'A07604621',
                result: {
                    referenceNo: 'MEH-FI-2026-012',
                    passportNo: 'A07604621',
                    name: 'Mahedi Hasan',
                    dateOfBirth: '15 March 1997',
                    courseEvents: 'Business & Entrepreneurship Professional Development Program',
                    courseDate: '11 April 2026 to 15 April 2026',
                    status: 'Confirmed',
                    location: 'Finland'
                }
            },
            {
                referenceNumber: 'MEH-FI-2026-024',
                passportNumber: 'DM5573902',
                result: {
                    referenceNo: 'MEH-FI-2026-024',
                    passportNo: 'DM5573902',
                    name: 'Hasnain Safdar',
                    dateOfBirth: '06 Jan 1994',
                    courseEvents: 'Food & Culinary Skills Professional Development Program',
                    courseDate: '05 April 2026 to 11 April 2026',
                    status: 'Confirmed',
                    location: 'Finland'
                }
            },
            // Template for adding new users - Replace the placeholder values below with actual user data
            // {
            //     referenceNumber: 'REF-XXXX-XXXX',
            //     passportNumber: 'XXXXXXXXX',
            //     result: {
            //         referenceNo: 'REF-XXXX-XXXX',
            //         passportNo: 'XXXXXXXXX',
            //         name: 'Full Name',
            //         dateOfBirth: 'DD Month YYYY',
            //         courseEvents: 'Course/Event Name',
            //         courseDate: 'DD Month YYYY – DD Month YYYY',
            //         status: 'Confirmed',
            //         location: 'City, Country'
            //     }
            // }
        ];

        // Function to normalize text - handles special Unicode characters from Google Sheets
        const normalizeText = (text) => {
            if (!text) return '';
            return text
                .toString()
                // Remove all control characters (invisible formatting characters)
                .replace(/[\x00-\x1F\x7F-\x9F]/g, '')
                // Replace all types of dashes and hyphens (including en-dash, em-dash, etc.) with regular hyphen
                .replace(/[\u2013\u2014\u2015\u2212\uFE58\uFE63\uFF0D\u058A\u05BE\u1400\u1806\u2010\u2011\u2E17\u2E1A\u2E3A\u2E3B\u301C\u3030\u30A0\uFE31\uFE32]/g, '-')
                // Replace all types of spaces (non-breaking, en-space, em-space, thin space, etc.) with regular space
                .replace(/[\u00A0\u1680\u2000-\u200B\u202F\u205F\u3000]/g, ' ')
                // Remove zero-width characters (zero-width space, zero-width non-joiner, etc.)
                .replace(/[\u200B-\u200D\uFEFF]/g, '')
                // Remove directional marks (left-to-right mark, right-to-left mark, etc.)
                .replace(/[\u200E\u200F\u202A-\u202E]/g, '')
                // Remove word joiner and other invisible formatting
                .replace(/[\u2060-\u206F]/g, '')
                // Replace tabs, newlines, and carriage returns with spaces
                .replace(/[\t\n\r]+/g, ' ')
                // Normalize multiple spaces to single space
                .replace(/\s+/g, ' ')
                // Trim and convert to uppercase
                .trim()
                .toUpperCase();
        };

        // Additional aggressive normalization for Google Sheets edge cases
        const aggressiveNormalize = (text) => {
            if (!text) return '';
            return text
                .toString()
                // Replace all types of dashes/hyphens with regular hyphen
                .replace(/[-–—−‐‑‒―─━\u2013\u2014\u2015\u2212\uFE58\uFE63\uFF0D]/g, '-')
                // Remove all non-alphanumeric characters except hyphens and spaces
                .replace(/[^A-Za-z0-9\s-]/g, '')
                // Normalize spaces
                .replace(/\s+/g, ' ')
                .trim()
                .toUpperCase();
        };

        // Simulate API call - Replace this with your actual API integration
        setTimeout(() => {
            // Normalize input for comparison (handles special Unicode characters from Google Sheets)
            const normalizedRef = normalizeText(formData.referenceNumber);
            const normalizedPassport = normalizeText(formData.passportNumber);
            
            // Find a matching record by both reference and passport numbers (case-insensitive)
            // Also normalize the records to handle any special characters in stored data
            let match = records.find(r => 
                normalizeText(r.referenceNumber) === normalizedRef && 
                normalizeText(r.passportNumber) === normalizedPassport
            );

            // If no match found, try aggressive normalization (for Google Sheets edge cases)
            if (!match) {
                const aggressiveRef = aggressiveNormalize(formData.referenceNumber);
                const aggressivePassport = aggressiveNormalize(formData.passportNumber);
                
                match = records.find(r => 
                    aggressiveNormalize(r.referenceNumber) === aggressiveRef && 
                    aggressiveNormalize(r.passportNumber) === aggressivePassport
                );
            }

            if (match) {
                setVerificationResult(match.result);
            } else {
                setVerificationResult({
                    error: true,
                    message: 'No record found with the provided Reference Number and Passport Number.'
                });
            }
            setIsSearching(false);
        }, 1000);
    };

    return (
        <section className="verification-form-section section-padding">
            <div className="container">
                <div className="row justify-content-center">
                    <div className={`col-lg-${verificationResult ? '6' : '10'} col-md-${verificationResult ? '8' : '12'} col-12`}>
                        <div className={`verification-form-wrapper ${verificationResult ? 'minimized' : ''}`}>
                            <div className="verification-form-header">
                                <h2>Check Your Registration</h2>
                            </div>
                            <form onSubmit={handleSubmit} className="verification-form">
                                <div className="form-row">
                                    <div className="form-field">
                                        <input
                                            type="text"
                                            name="referenceNumber"
                                            placeholder="Enter your Reference Number"
                                            value={formData.referenceNumber}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-field">
                                        <input
                                            type="text"
                                            name="passportNumber"
                                            placeholder="Enter your Passport Number"
                                            value={formData.passportNumber}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-field">
                                        <button type="submit" className="verification-submit-btn" disabled={isSearching}>
                                            {isSearching ? 'Checking...' : 'Check Status'}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Popup Overlay */}
            {verificationResult && (
                <div className="verification-popup-overlay">
                    <div className="verification-popup">
                        {verificationResult.error ? (
                            <div className="verification-error">
                                <i className="fi flaticon-close"></i>
                                <h3>No Record Found</h3>
                                <p>{verificationResult.message}</p>
                                <button 
                                    type="button" 
                                    className="go-back-btn"
                                    onClick={() => {
                                        setVerificationResult(null);
                                    }}
                                >
                                    Go Back
                                </button>
                            </div>
                        ) : (
                            <div className="verification-details-card">
                                <div className="detail-item">
                                    <span className="detail-label">Passport No.:</span>
                                    <span className="detail-value">{verificationResult.passportNo}</span>
                                </div>
                                
                                <div className="detail-item">
                                    <span className="detail-label">Name:</span>
                                    <span className="detail-value">{verificationResult.name}</span>
                                </div>
                                
                                <div className="detail-item">
                                    <span className="detail-label">Date Of Birth:</span>
                                    <span className="detail-value">{verificationResult.dateOfBirth}</span>
                                </div>
                                
                                <div className="detail-item">
                                    <span className="detail-label">Course/Event:</span>
                                    <span className="detail-value">{verificationResult.courseEvents}</span>
                                </div>
                                
                                <div className="detail-item">
                                    <span className="detail-label">Date:</span>
                                    <span className="detail-value">{verificationResult.courseDate}</span>
                                </div>
                                
                                <div className="detail-item">
                                    <span className="detail-label">Location:</span>
                                    <span className="detail-value">{verificationResult.location}</span>
                                </div>
                                
                                <div className="detail-item">
                                    <span className="detail-label">Status:</span>
                                    <span className="detail-value status-active">{verificationResult.status}</span>
                                </div>
                                
                                <button 
                                    type="button" 
                                    className="go-back-btn"
                                    onClick={() => {
                                        setVerificationResult(null);
                                        setFormData({ referenceNumber: '', passportNumber: '' });
                                    }}
                                >
                                    Go Back
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </section>
    );
};

export default VerificationForm;

